(function () {
  function initSwipe(container) {
    const mainImg = container.querySelector('.card__img:not(.card__img--hover)');
    if (!mainImg) return;

    const rawImages = container.dataset.productImages;
    if (!rawImages) return;

    const images = rawImages.split(',').map(src => src.trim().split('?')[0]);
    if (images.length < 2) return;

    // 카드 비율(높이)이 망가지지 않도록 원본 이미지는 투명하게만 만듭니다.
    mainImg.style.opacity = '0';

    // 네이티브 스와이프 전용 가로 스크롤 컨테이너 생성
    const scroller = document.createElement('div');
    scroller.className = 'native-swipe-scroller';

    // 스크롤 컨테이너 안에 이미지들 나열
    images.forEach(src => {
      const img = document.createElement('img');
      img.src = src + '?width=600';
      img.className = 'native-swipe-img';
      img.loading = 'lazy'; // 로딩 속도 최적화
      scroller.appendChild(img);
    });

    // 컨테이너에 삽입
    mainImg.parentNode.insertBefore(scroller, mainImg);

    // 트랙 + 움직이는 인디케이터 바 생성
    const track = document.createElement('div');
    track.className = 'swipe-track';
    const indicator = document.createElement('div');
    indicator.className = 'swipe-indicator';
    
    track.appendChild(indicator);
    container.appendChild(track);

    // 바의 너비 계산
    const indicatorWidthPct = 100 / images.length;
    indicator.style.width = indicatorWidthPct + '%';

    // 스크롤 위치에 맞춰 인디케이터 1:1 실시간 동기화
    scroller.addEventListener('scroll', () => {
      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      if (maxScroll <= 0) return;
      const scrollRatio = scroller.scrollLeft / maxScroll;
      const maxOffset = 100 - indicatorWidthPct;
      indicator.style.left = (scrollRatio * maxOffset) + '%';
    }, { passive: true });
  }

  function init() {
    // 🛑 1번째 관문: PC(데스크탑) 차단
    // 화면 가로 길이가 768px 초과(아이패드 가로 및 PC)면 기능 실행 안 함
    if (window.innerWidth > 768) return;

    // 🛑 2번째 관문: 특정 페이지에서만 허용
    // body 태그의 클래스를 확인하여 현재 페이지 템플릿 파악
    const isIndex = document.body.classList.contains('template-index');
    const isCollection = document.body.classList.contains('template-collection');

    // 메인(index)도 아니고 컬렉션(collection)도 아니면 기능 실행 안 함
    if (!isIndex && !isCollection) return;

    // 관문을 모두 통과한 경우에만 스와이프 기능 적용
    document.querySelectorAll('[data-swipeable="true"]').forEach(initSwipe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();